export default {
  validate: async (value, { phrases, passIncomplete = true }) => {
    if ([undefined, null, ''].includes(value)) {
      return false;
    }

    const phrasesArray = Array.isArray(phrases) ? phrases : [phrases];

    const valid = phrasesArray.some(phrase => {
      const lettersQty = passIncomplete ? Math.min(value.length, phrase.length) : phrase.length;
      return [...Array(lettersQty).keys()].every(index => phrase[index] === value[index]);
    });

    return valid;
  },
  params: ['phrases', 'passIncomplete'],
  message: (fieldName, { phrases }) => {
    const phrasesArray = Array.isArray(phrases) ? phrases : [phrases];
    const msg = `The ${fieldName} field must begin with `;

    if (phrasesArray.length === 1) {
      return `${msg}${phrasesArray[0]}.`;
    } else if (phrasesArray.length > 1) {
      return `${msg}any of these values: ${phrasesArray.join(', ')}.`;
    }
    return 'Error';
  },
};
